var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefitsSubimageIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.109375,
    y: 0.414062,
    width: 56,
    height: 56,
    rx: 8,
    fill: "#F5AEAF",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8333 36.1667C31.988 36.1667 36.1667 31.988 36.1667 26.8333C36.1667 21.6787 31.988 17.5 26.8333 17.5C21.6787 17.5 17.5 21.6787 17.5 26.8333C17.5 31.988 21.6787 36.1667 26.8333 36.1667Z",
    stroke: "#EC6B6C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2726 30.9911L23.2636 31L23.2542 30.9911H22.4464C22.328 30.991 22.2144 30.9445 22.1307 30.8618C22.047 30.7792 22 30.6671 22 30.5503V23.4408C22.0008 23.3243 22.0481 23.2127 22.1316 23.1302C22.2152 23.0477 22.3282 23.0009 22.4464 23H30.5536C30.8002 23 31 23.1976 31 23.4408V30.5503C30.9992 30.6669 30.9519 30.7785 30.8684 30.8609C30.7848 30.9434 30.6718 30.9902 30.5536 30.9911H23.2726ZM30.1 28.3274V23.8879H22.9V30.1032L27.4 25.6637L30.1 28.3274ZM30.1 29.5829L27.4 26.9192L24.1726 30.1032H30.1V29.5829ZM24.7 26.5516C24.4613 26.5516 24.2324 26.4581 24.0636 26.2915C23.8948 26.125 23.8 25.8992 23.8 25.6637C23.8 25.4282 23.8948 25.2024 24.0636 25.0359C24.2324 24.8694 24.4613 24.7758 24.7 24.7758C24.9387 24.7758 25.1676 24.8694 25.3364 25.0359C25.5052 25.2024 25.6 25.4282 25.6 25.6637C25.6 25.8992 25.5052 26.125 25.3364 26.2915C25.1676 26.4581 24.9387 26.5516 24.7 26.5516Z",
    fill: "#EC6B6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.499 38.5002L33.424 33.4252",
    stroke: "#EC6B6C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitsSubimageIcon2);
export default __webpack_public_path__ + "static/media/benefits_subimage_icon_2.2016b62a97b9333f400d04e3da331a0c.svg";
export { ForwardRef as ReactComponent };